import { COUNTRY_CODE, COUNTRY_ID } from '../typings/countries';

export class CountryCodeMapper {
    static GetCountryId(country: string) {
        if ((country.toUpperCase() as COUNTRY_CODE) === COUNTRY_CODE.US) {
            return COUNTRY_ID.US;
        }

        return COUNTRY_ID.GB;
    }
}
